//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { environment } from "@environments/environment";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class Foo {
  protected getBaseUrl(deaultUrl: string): string {
    return environment.remoteServiceBaseUrl;
  }
}

@Injectable({
    providedIn: 'root'
})
export class GuestCalendarServiceProxy extends Foo {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * @param url (optional) 
     * @return OK
     */
    getOwnerCalendarInfo(url: string | undefined): Observable<GetOwnerCalendarInfoOutput> {
        let url_ = this.baseUrl + "/api/services/app/GuestCalendar/GetOwnerCalendarInfo?";
        if (url === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "Url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOwnerCalendarInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOwnerCalendarInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOwnerCalendarInfoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOwnerCalendarInfoOutput>;
        }));
    }

    protected processGetOwnerCalendarInfo(response: HttpResponseBase): Observable<GetOwnerCalendarInfoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOwnerCalendarInfoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getOwnerCalendarInfoFromAttendanceId(id: string | undefined): Observable<GetOwnerCalendarInfoOutput> {
        let url_ = this.baseUrl + "/api/services/app/GuestCalendar/GetOwnerCalendarInfoFromAttendanceId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOwnerCalendarInfoFromAttendanceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOwnerCalendarInfoFromAttendanceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOwnerCalendarInfoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOwnerCalendarInfoOutput>;
        }));
    }

    protected processGetOwnerCalendarInfoFromAttendanceId(response: HttpResponseBase): Observable<GetOwnerCalendarInfoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOwnerCalendarInfoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGuestMeeting(body: GuestAddMeetingInput | undefined): Observable<CreateGuestMeetingOutput> {
        let url_ = this.baseUrl + "/api/services/app/GuestCalendar/CreateGuestMeeting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGuestMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGuestMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateGuestMeetingOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateGuestMeetingOutput>;
        }));
    }

    protected processCreateGuestMeeting(response: HttpResponseBase): Observable<CreateGuestMeetingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateGuestMeetingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSlotsForId(start: Date, end: Date, duration: number, id: string | undefined): Observable<GetSlotsOutput> {
        let url_ = this.baseUrl + "/api/services/app/GuestCalendar/GetSlotsForId?";
        if (start === undefined || start === null)
            throw new Error("The parameter 'start' must be defined and cannot be null.");
        else
            url_ += "Start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === undefined || end === null)
            throw new Error("The parameter 'end' must be defined and cannot be null.");
        else
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (duration === undefined || duration === null)
            throw new Error("The parameter 'duration' must be defined and cannot be null.");
        else
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlotsForId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlotsForId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSlotsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSlotsOutput>;
        }));
    }

    protected processGetSlotsForId(response: HttpResponseBase): Observable<GetSlotsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSlotsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAttendanceDetails(id: string | undefined): Observable<GetAttendanceDetailsOutput> {
        let url_ = this.baseUrl + "/api/services/app/GuestCalendar/GetAttendanceDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceDetailsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceDetailsOutput>;
        }));
    }

    protected processGetAttendanceDetails(response: HttpResponseBase): Observable<GetAttendanceDetailsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceDetailsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancelAttendanceAsGuest(body: CancelAttendanceAsyncInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GuestCalendar/CancelAttendanceAsGuest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelAttendanceAsGuest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelAttendanceAsGuest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelAttendanceAsGuest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param stripePaymentIntentId (optional) 
     * @return OK
     */
    tryCompletePaidBooking(stripePaymentIntentId: string | undefined): Observable<AttendanceDto> {
        let url_ = this.baseUrl + "/api/services/app/GuestCalendar/TryCompletePaidBooking?";
        if (stripePaymentIntentId === null)
            throw new Error("The parameter 'stripePaymentIntentId' cannot be null.");
        else if (stripePaymentIntentId !== undefined)
            url_ += "stripePaymentIntentId=" + encodeURIComponent("" + stripePaymentIntentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTryCompletePaidBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTryCompletePaidBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceDto>;
        }));
    }

    protected processTryCompletePaidBooking(response: HttpResponseBase): Observable<AttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSessionUserLanguage(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/GuestCalendar/GetSessionUserLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSessionUserLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSessionUserLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSessionUserLanguage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AttendanceDto implements IAttendanceDto {
    id!: string;
    calendarEventId!: string;
    attendeeName!: string | undefined;
    attendeeEmail!: string | undefined;
    reason!: string | undefined;
    deleter!: string | undefined;
    guestQuestionAnswers!: GuestQuestionAnswers[] | undefined;
    eventTypeId!: string;
    creationTime!: Date;
    timeZone!: string | undefined;
    rescheduledFrom!: AttendanceDto;
    isDeleted!: boolean;
    paymentAmount!: number;
    paymentCurrency!: string | undefined;
    paymentAccountId!: string | undefined;
    paymentReference!: string | undefined;

    constructor(data?: IAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.guestQuestionAnswers) {
                this.guestQuestionAnswers = [];
                for (let i = 0; i < data.guestQuestionAnswers.length; i++) {
                    let item = data.guestQuestionAnswers[i];
                    this.guestQuestionAnswers[i] = item && !(<any>item).toJSON ? new GuestQuestionAnswers(item) : <GuestQuestionAnswers>item;
                }
            }
            this.rescheduledFrom = data.rescheduledFrom && !(<any>data.rescheduledFrom).toJSON ? new AttendanceDto(data.rescheduledFrom) : <AttendanceDto>this.rescheduledFrom;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.calendarEventId = _data["calendarEventId"];
            this.attendeeName = _data["attendeeName"];
            this.attendeeEmail = _data["attendeeEmail"];
            this.reason = _data["reason"];
            this.deleter = _data["deleter"];
            if (Array.isArray(_data["guestQuestionAnswers"])) {
                this.guestQuestionAnswers = [] as any;
                for (let item of _data["guestQuestionAnswers"])
                    this.guestQuestionAnswers!.push(GuestQuestionAnswers.fromJS(item));
            }
            this.eventTypeId = _data["eventTypeId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.rescheduledFrom = _data["rescheduledFrom"] ? AttendanceDto.fromJS(_data["rescheduledFrom"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.paymentAmount = _data["paymentAmount"];
            this.paymentCurrency = _data["paymentCurrency"];
            this.paymentAccountId = _data["paymentAccountId"];
            this.paymentReference = _data["paymentReference"];
        }
    }

    static fromJS(data: any): AttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["calendarEventId"] = this.calendarEventId;
        data["attendeeName"] = this.attendeeName;
        data["attendeeEmail"] = this.attendeeEmail;
        data["reason"] = this.reason;
        data["deleter"] = this.deleter;
        if (Array.isArray(this.guestQuestionAnswers)) {
            data["guestQuestionAnswers"] = [];
            for (let item of this.guestQuestionAnswers)
                data["guestQuestionAnswers"].push(item.toJSON());
        }
        data["eventTypeId"] = this.eventTypeId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["rescheduledFrom"] = this.rescheduledFrom ? this.rescheduledFrom.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentCurrency"] = this.paymentCurrency;
        data["paymentAccountId"] = this.paymentAccountId;
        data["paymentReference"] = this.paymentReference;
        return data;
    }
}

export interface IAttendanceDto {
    id: string;
    calendarEventId: string;
    attendeeName: string | undefined;
    attendeeEmail: string | undefined;
    reason: string | undefined;
    deleter: string | undefined;
    guestQuestionAnswers: IGuestQuestionAnswers[] | undefined;
    eventTypeId: string;
    creationTime: Date;
    timeZone: string | undefined;
    rescheduledFrom: IAttendanceDto;
    isDeleted: boolean;
    paymentAmount: number;
    paymentCurrency: string | undefined;
    paymentAccountId: string | undefined;
    paymentReference: string | undefined;
}

export class CalendarAvailability implements ICalendarAvailability {
    individual!: { [key: string]: TimeRange[]; } | undefined;
    weeklyRepeating!: { [key: string]: TimeRange[]; } | undefined;

    constructor(data?: ICalendarAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["individual"]) {
                this.individual = {} as any;
                for (let key in _data["individual"]) {
                    if (_data["individual"].hasOwnProperty(key))
                        (<any>this.individual)![key] = _data["individual"][key] ? _data["individual"][key].map((i: any) => TimeRange.fromJS(i)) : <any>undefined;
                }
            }
            if (_data["weeklyRepeating"]) {
                this.weeklyRepeating = {} as any;
                for (let key in _data["weeklyRepeating"]) {
                    if (_data["weeklyRepeating"].hasOwnProperty(key))
                        (<any>this.weeklyRepeating)![key] = _data["weeklyRepeating"][key] ? _data["weeklyRepeating"][key].map((i: any) => TimeRange.fromJS(i)) : <any>undefined;
                }
            }
        }
    }

    static fromJS(data: any): CalendarAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.individual) {
            data["individual"] = {};
            for (let key in this.individual) {
                if (this.individual.hasOwnProperty(key))
                    (<any>data["individual"])[key] = (<any>this.individual)[key];
            }
        }
        if (this.weeklyRepeating) {
            data["weeklyRepeating"] = {};
            for (let key in this.weeklyRepeating) {
                if (this.weeklyRepeating.hasOwnProperty(key))
                    (<any>data["weeklyRepeating"])[key] = (<any>this.weeklyRepeating)[key];
            }
        }
        return data;
    }
}

export interface ICalendarAvailability {
    individual: { [key: string]: TimeRange[]; } | undefined;
    weeklyRepeating: { [key: string]: TimeRange[]; } | undefined;
}

export class CalendarOptions implements ICalendarOptions {
    profilePic!: string | undefined;
    meetingLengths!: number[] | undefined;
    availabilityIncrements!: number;
    minimumNoticeMinutes!: number;
    calendarAvailability!: CalendarAvailability;
    description!: string | undefined;
    headline!: string | undefined;
    subline!: string | undefined;
    color!: string | undefined;
    dateRangeType!: string | undefined;
    dateRangeRollingPeriod!: number | undefined;
    dateRangeDateRange!: DateTimeRange;
    location!: string | undefined;
    showLocationBeforeConfirmation!: boolean;
    locationSetting!: LocationSettingEnum;
    guestChoosesLocation!: boolean;
    guestLocationFreeChoice!: boolean;
    guestLocationChoices!: string[] | undefined;
    guestChoosesLocationQuestionText!: string | undefined;
    guestLocationChoicesAllowOther!: boolean;
    guestQuestions!: GuestQuestion[] | undefined;
    reminderEmailSettings!: number[] | undefined;
    maxAttendees!: number;

    constructor(data?: ICalendarOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarAvailability = data.calendarAvailability && !(<any>data.calendarAvailability).toJSON ? new CalendarAvailability(data.calendarAvailability) : <CalendarAvailability>this.calendarAvailability;
            this.dateRangeDateRange = data.dateRangeDateRange && !(<any>data.dateRangeDateRange).toJSON ? new DateTimeRange(data.dateRangeDateRange) : <DateTimeRange>this.dateRangeDateRange;
            if (data.guestQuestions) {
                this.guestQuestions = [];
                for (let i = 0; i < data.guestQuestions.length; i++) {
                    let item = data.guestQuestions[i];
                    this.guestQuestions[i] = item && !(<any>item).toJSON ? new GuestQuestion(item) : <GuestQuestion>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePic = _data["profilePic"];
            if (Array.isArray(_data["meetingLengths"])) {
                this.meetingLengths = [] as any;
                for (let item of _data["meetingLengths"])
                    this.meetingLengths!.push(item);
            }
            this.availabilityIncrements = _data["availabilityIncrements"];
            this.minimumNoticeMinutes = _data["minimumNoticeMinutes"];
            this.calendarAvailability = _data["calendarAvailability"] ? CalendarAvailability.fromJS(_data["calendarAvailability"]) : <any>undefined;
            this.description = _data["description"];
            this.headline = _data["headline"];
            this.subline = _data["subline"];
            this.color = _data["color"];
            this.dateRangeType = _data["dateRangeType"];
            this.dateRangeRollingPeriod = _data["dateRangeRollingPeriod"];
            this.dateRangeDateRange = _data["dateRangeDateRange"] ? DateTimeRange.fromJS(_data["dateRangeDateRange"]) : <any>undefined;
            this.location = _data["location"];
            this.showLocationBeforeConfirmation = _data["showLocationBeforeConfirmation"];
            this.locationSetting = _data["locationSetting"];
            this.guestChoosesLocation = _data["guestChoosesLocation"];
            this.guestLocationFreeChoice = _data["guestLocationFreeChoice"];
            if (Array.isArray(_data["guestLocationChoices"])) {
                this.guestLocationChoices = [] as any;
                for (let item of _data["guestLocationChoices"])
                    this.guestLocationChoices!.push(item);
            }
            this.guestChoosesLocationQuestionText = _data["guestChoosesLocationQuestionText"];
            this.guestLocationChoicesAllowOther = _data["guestLocationChoicesAllowOther"];
            if (Array.isArray(_data["guestQuestions"])) {
                this.guestQuestions = [] as any;
                for (let item of _data["guestQuestions"])
                    this.guestQuestions!.push(GuestQuestion.fromJS(item));
            }
            if (Array.isArray(_data["reminderEmailSettings"])) {
                this.reminderEmailSettings = [] as any;
                for (let item of _data["reminderEmailSettings"])
                    this.reminderEmailSettings!.push(item);
            }
            this.maxAttendees = _data["maxAttendees"];
        }
    }

    static fromJS(data: any): CalendarOptions {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePic"] = this.profilePic;
        if (Array.isArray(this.meetingLengths)) {
            data["meetingLengths"] = [];
            for (let item of this.meetingLengths)
                data["meetingLengths"].push(item);
        }
        data["availabilityIncrements"] = this.availabilityIncrements;
        data["minimumNoticeMinutes"] = this.minimumNoticeMinutes;
        data["calendarAvailability"] = this.calendarAvailability ? this.calendarAvailability.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["headline"] = this.headline;
        data["subline"] = this.subline;
        data["color"] = this.color;
        data["dateRangeType"] = this.dateRangeType;
        data["dateRangeRollingPeriod"] = this.dateRangeRollingPeriod;
        data["dateRangeDateRange"] = this.dateRangeDateRange ? this.dateRangeDateRange.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["showLocationBeforeConfirmation"] = this.showLocationBeforeConfirmation;
        data["locationSetting"] = this.locationSetting;
        data["guestChoosesLocation"] = this.guestChoosesLocation;
        data["guestLocationFreeChoice"] = this.guestLocationFreeChoice;
        if (Array.isArray(this.guestLocationChoices)) {
            data["guestLocationChoices"] = [];
            for (let item of this.guestLocationChoices)
                data["guestLocationChoices"].push(item);
        }
        data["guestChoosesLocationQuestionText"] = this.guestChoosesLocationQuestionText;
        data["guestLocationChoicesAllowOther"] = this.guestLocationChoicesAllowOther;
        if (Array.isArray(this.guestQuestions)) {
            data["guestQuestions"] = [];
            for (let item of this.guestQuestions)
                data["guestQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.reminderEmailSettings)) {
            data["reminderEmailSettings"] = [];
            for (let item of this.reminderEmailSettings)
                data["reminderEmailSettings"].push(item);
        }
        data["maxAttendees"] = this.maxAttendees;
        return data;
    }
}

export interface ICalendarOptions {
    profilePic: string | undefined;
    meetingLengths: number[] | undefined;
    availabilityIncrements: number;
    minimumNoticeMinutes: number;
    calendarAvailability: ICalendarAvailability;
    description: string | undefined;
    headline: string | undefined;
    subline: string | undefined;
    color: string | undefined;
    dateRangeType: string | undefined;
    dateRangeRollingPeriod: number | undefined;
    dateRangeDateRange: IDateTimeRange;
    location: string | undefined;
    showLocationBeforeConfirmation: boolean;
    locationSetting: LocationSettingEnum;
    guestChoosesLocation: boolean;
    guestLocationFreeChoice: boolean;
    guestLocationChoices: string[] | undefined;
    guestChoosesLocationQuestionText: string | undefined;
    guestLocationChoicesAllowOther: boolean;
    guestQuestions: IGuestQuestion[] | undefined;
    reminderEmailSettings: number[] | undefined;
    maxAttendees: number;
}

export class CalendarSlot implements ICalendarSlot {
    startTime!: Date;
    endTime!: Date;

    constructor(data?: ICalendarSlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CalendarSlot {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarSlot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICalendarSlot {
    startTime: Date;
    endTime: Date;
}

export class CancelAttendanceAsyncInput implements ICancelAttendanceAsyncInput {
    id!: string;
    reason!: string | undefined;

    constructor(data?: ICancelAttendanceAsyncInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CancelAttendanceAsyncInput {
        data = typeof data === 'object' ? data : {};
        let result = new CancelAttendanceAsyncInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ICancelAttendanceAsyncInput {
    id: string;
    reason: string | undefined;
}

export class CreateGuestMeetingOutput implements ICreateGuestMeetingOutput {
    paymentIntentId!: string | undefined;
    attendance!: AttendanceDto;

    constructor(data?: ICreateGuestMeetingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.attendance = data.attendance && !(<any>data.attendance).toJSON ? new AttendanceDto(data.attendance) : <AttendanceDto>this.attendance;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentIntentId = _data["paymentIntentId"];
            this.attendance = _data["attendance"] ? AttendanceDto.fromJS(_data["attendance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateGuestMeetingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGuestMeetingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentIntentId"] = this.paymentIntentId;
        data["attendance"] = this.attendance ? this.attendance.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateGuestMeetingOutput {
    paymentIntentId: string | undefined;
    attendance: IAttendanceDto;
}

export class DateTimeRange implements IDateTimeRange {
    startTime!: Date;
    endTime!: Date;

    constructor(data?: IDateTimeRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateTimeRange {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDateTimeRange {
    startTime: Date;
    endTime: Date;
}

export class DurationPackageDto implements IDurationPackageDto {
    id!: string;
    minutes!: number;
    paymentAmount!: number;

    constructor(data?: IDurationPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.minutes = _data["minutes"];
            this.paymentAmount = _data["paymentAmount"];
        }
    }

    static fromJS(data: any): DurationPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DurationPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minutes"] = this.minutes;
        data["paymentAmount"] = this.paymentAmount;
        return data;
    }
}

export interface IDurationPackageDto {
    id: string;
    minutes: number;
    paymentAmount: number;
}

export enum EventTypes {
    _0 = 0,
    _1 = 1,
}

export class GetAttendanceDetailsOutput implements IGetAttendanceDetailsOutput {
    id!: string;
    startTime!: Date;
    timeZone!: string | undefined;
    duration!: number;
    endTime!: Date;
    eventName!: string | undefined;
    ownerId!: number;
    ownerFirstName!: string | undefined;
    ownerLastName!: string | undefined;
    calendarEventId!: string | undefined;
    location!: string | undefined;
    color!: string | undefined;
    description!: string | undefined;
    isDeleted!: boolean;
    attendeeName!: string | undefined;
    meetingUrl!: string | undefined;
    hostFirstName!: string | undefined;
    hostLastName!: string | undefined;
    calendarEventZoomMeetingUrl!: string | undefined;
    calendarEventZoomMeetingPassword!: string | undefined;
    calendarEventGoogleMeetingPassword!: string | undefined;
    calendarEventGoogleMeetingUrl!: string | undefined;
    calendarEventMicrosoftMeetingingUrl!: string | undefined;
    calendarEventMicrosoftMeetingingPassword!: string | undefined;
    hasPremium!: boolean;

    constructor(data?: IGetAttendanceDetailsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.duration = _data["duration"];
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.eventName = _data["eventName"];
            this.ownerId = _data["ownerId"];
            this.ownerFirstName = _data["ownerFirstName"];
            this.ownerLastName = _data["ownerLastName"];
            this.calendarEventId = _data["calendarEventId"];
            this.location = _data["location"];
            this.color = _data["color"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.attendeeName = _data["attendeeName"];
            this.meetingUrl = _data["meetingUrl"];
            this.hostFirstName = _data["hostFirstName"];
            this.hostLastName = _data["hostLastName"];
            this.calendarEventZoomMeetingUrl = _data["calendarEventZoomMeetingUrl"];
            this.calendarEventZoomMeetingPassword = _data["calendarEventZoomMeetingPassword"];
            this.calendarEventGoogleMeetingPassword = _data["calendarEventGoogleMeetingPassword"];
            this.calendarEventGoogleMeetingUrl = _data["calendarEventGoogleMeetingUrl"];
            this.calendarEventMicrosoftMeetingingUrl = _data["calendarEventMicrosoftMeetingingUrl"];
            this.calendarEventMicrosoftMeetingingPassword = _data["calendarEventMicrosoftMeetingingPassword"];
            this.hasPremium = _data["hasPremium"];
        }
    }

    static fromJS(data: any): GetAttendanceDetailsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceDetailsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["duration"] = this.duration;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["eventName"] = this.eventName;
        data["ownerId"] = this.ownerId;
        data["ownerFirstName"] = this.ownerFirstName;
        data["ownerLastName"] = this.ownerLastName;
        data["calendarEventId"] = this.calendarEventId;
        data["location"] = this.location;
        data["color"] = this.color;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["attendeeName"] = this.attendeeName;
        data["meetingUrl"] = this.meetingUrl;
        data["hostFirstName"] = this.hostFirstName;
        data["hostLastName"] = this.hostLastName;
        data["calendarEventZoomMeetingUrl"] = this.calendarEventZoomMeetingUrl;
        data["calendarEventZoomMeetingPassword"] = this.calendarEventZoomMeetingPassword;
        data["calendarEventGoogleMeetingPassword"] = this.calendarEventGoogleMeetingPassword;
        data["calendarEventGoogleMeetingUrl"] = this.calendarEventGoogleMeetingUrl;
        data["calendarEventMicrosoftMeetingingUrl"] = this.calendarEventMicrosoftMeetingingUrl;
        data["calendarEventMicrosoftMeetingingPassword"] = this.calendarEventMicrosoftMeetingingPassword;
        data["hasPremium"] = this.hasPremium;
        return data;
    }
}

export interface IGetAttendanceDetailsOutput {
    id: string;
    startTime: Date;
    timeZone: string | undefined;
    duration: number;
    endTime: Date;
    eventName: string | undefined;
    ownerId: number;
    ownerFirstName: string | undefined;
    ownerLastName: string | undefined;
    calendarEventId: string | undefined;
    location: string | undefined;
    color: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    attendeeName: string | undefined;
    meetingUrl: string | undefined;
    hostFirstName: string | undefined;
    hostLastName: string | undefined;
    calendarEventZoomMeetingUrl: string | undefined;
    calendarEventZoomMeetingPassword: string | undefined;
    calendarEventGoogleMeetingPassword: string | undefined;
    calendarEventGoogleMeetingUrl: string | undefined;
    calendarEventMicrosoftMeetingingUrl: string | undefined;
    calendarEventMicrosoftMeetingingPassword: string | undefined;
    hasPremium: boolean;
}

export class GetOwnerCalendarInfoOutput implements IGetOwnerCalendarInfoOutput {
    id!: string;
    ownerId!: number;
    calendarOptions!: CalendarOptions;
    name!: string | undefined;
    url!: string | undefined;
    paymentAccountExternalId!: string | undefined;
    paymentAccountId!: string | undefined;
    paymentTerms!: string | undefined;
    durationPackages!: DurationPackageDto[] | undefined;
    paymentCurrency!: string | undefined;
    eventType!: EventTypes;
    location!: string | undefined;
    hasPremium!: boolean;

    constructor(data?: IGetOwnerCalendarInfoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarOptions = data.calendarOptions && !(<any>data.calendarOptions).toJSON ? new CalendarOptions(data.calendarOptions) : <CalendarOptions>this.calendarOptions;
            if (data.durationPackages) {
                this.durationPackages = [];
                for (let i = 0; i < data.durationPackages.length; i++) {
                    let item = data.durationPackages[i];
                    this.durationPackages[i] = item && !(<any>item).toJSON ? new DurationPackageDto(item) : <DurationPackageDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerId = _data["ownerId"];
            this.calendarOptions = _data["calendarOptions"] ? CalendarOptions.fromJS(_data["calendarOptions"]) : <any>undefined;
            this.name = _data["name"];
            this.url = _data["url"];
            this.paymentAccountExternalId = _data["paymentAccountExternalId"];
            this.paymentAccountId = _data["paymentAccountId"];
            this.paymentTerms = _data["paymentTerms"];
            if (Array.isArray(_data["durationPackages"])) {
                this.durationPackages = [] as any;
                for (let item of _data["durationPackages"])
                    this.durationPackages!.push(DurationPackageDto.fromJS(item));
            }
            this.paymentCurrency = _data["paymentCurrency"];
            this.eventType = _data["eventType"];
            this.location = _data["location"];
            this.hasPremium = _data["hasPremium"];
        }
    }

    static fromJS(data: any): GetOwnerCalendarInfoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOwnerCalendarInfoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerId"] = this.ownerId;
        data["calendarOptions"] = this.calendarOptions ? this.calendarOptions.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["url"] = this.url;
        data["paymentAccountExternalId"] = this.paymentAccountExternalId;
        data["paymentAccountId"] = this.paymentAccountId;
        data["paymentTerms"] = this.paymentTerms;
        if (Array.isArray(this.durationPackages)) {
            data["durationPackages"] = [];
            for (let item of this.durationPackages)
                data["durationPackages"].push(item.toJSON());
        }
        data["paymentCurrency"] = this.paymentCurrency;
        data["eventType"] = this.eventType;
        data["location"] = this.location;
        data["hasPremium"] = this.hasPremium;
        return data;
    }
}

export interface IGetOwnerCalendarInfoOutput {
    id: string;
    ownerId: number;
    calendarOptions: ICalendarOptions;
    name: string | undefined;
    url: string | undefined;
    paymentAccountExternalId: string | undefined;
    paymentAccountId: string | undefined;
    paymentTerms: string | undefined;
    durationPackages: IDurationPackageDto[] | undefined;
    paymentCurrency: string | undefined;
    eventType: EventTypes;
    location: string | undefined;
    hasPremium: boolean;
}

export class GetSlotsOutput implements IGetSlotsOutput {
    slots!: CalendarSlot[] | undefined;

    constructor(data?: IGetSlotsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.slots) {
                this.slots = [];
                for (let i = 0; i < data.slots.length; i++) {
                    let item = data.slots[i];
                    this.slots[i] = item && !(<any>item).toJSON ? new CalendarSlot(item) : <CalendarSlot>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(CalendarSlot.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSlotsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlotsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSlotsOutput {
    slots: ICalendarSlot[] | undefined;
}

export class GuestAddMeetingInput implements IGuestAddMeetingInput {
    url!: string | undefined;
    newMeetingDetails!: NewMeetingDetails;
    guestQuestionAnswersInput!: string[][] | undefined;

    constructor(data?: IGuestAddMeetingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.newMeetingDetails = data.newMeetingDetails && !(<any>data.newMeetingDetails).toJSON ? new NewMeetingDetails(data.newMeetingDetails) : <NewMeetingDetails>this.newMeetingDetails;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.newMeetingDetails = _data["newMeetingDetails"] ? NewMeetingDetails.fromJS(_data["newMeetingDetails"]) : <any>undefined;
            if (Array.isArray(_data["guestQuestionAnswersInput"])) {
                this.guestQuestionAnswersInput = [] as any;
                for (let item of _data["guestQuestionAnswersInput"])
                    this.guestQuestionAnswersInput!.push(item);
            }
        }
    }

    static fromJS(data: any): GuestAddMeetingInput {
        data = typeof data === 'object' ? data : {};
        let result = new GuestAddMeetingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["newMeetingDetails"] = this.newMeetingDetails ? this.newMeetingDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.guestQuestionAnswersInput)) {
            data["guestQuestionAnswersInput"] = [];
            for (let item of this.guestQuestionAnswersInput)
                data["guestQuestionAnswersInput"].push(item);
        }
        return data;
    }
}

export interface IGuestAddMeetingInput {
    url: string | undefined;
    newMeetingDetails: INewMeetingDetails;
    guestQuestionAnswersInput: string[][] | undefined;
}

export class GuestQuestion implements IGuestQuestion {
    enabled!: boolean;
    required!: boolean;
    question!: string;
    answerType!: string;
    choices!: string[] | undefined;
    freeChoice!: boolean | undefined;

    constructor(data?: IGuestQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.required = _data["required"];
            this.question = _data["question"];
            this.answerType = _data["answerType"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(item);
            }
            this.freeChoice = _data["freeChoice"];
        }
    }

    static fromJS(data: any): GuestQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new GuestQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["required"] = this.required;
        data["question"] = this.question;
        data["answerType"] = this.answerType;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item);
        }
        data["freeChoice"] = this.freeChoice;
        return data;
    }
}

export interface IGuestQuestion {
    enabled: boolean;
    required: boolean;
    question: string;
    answerType: string;
    choices: string[] | undefined;
    freeChoice: boolean | undefined;
}

export class GuestQuestionAnswers implements IGuestQuestionAnswers {
    answerType!: string | undefined;
    question!: string | undefined;
    answers!: string[] | undefined;

    constructor(data?: IGuestQuestionAnswers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answerType = _data["answerType"];
            this.question = _data["question"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(item);
            }
        }
    }

    static fromJS(data: any): GuestQuestionAnswers {
        data = typeof data === 'object' ? data : {};
        let result = new GuestQuestionAnswers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerType"] = this.answerType;
        data["question"] = this.question;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item);
        }
        return data;
    }
}

export interface IGuestQuestionAnswers {
    answerType: string | undefined;
    question: string | undefined;
    answers: string[] | undefined;
}

export enum LocationSettingEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class NewMeetingDetails implements INewMeetingDetails {
    start!: Date;
    duration!: number;
    timeZone!: string | undefined;
    attendeeName!: string | undefined;
    attendeeEmail!: string | undefined;
    location!: string | undefined;
    language!: string | undefined;

    constructor(data?: INewMeetingDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.timeZone = _data["timeZone"];
            this.attendeeName = _data["attendeeName"];
            this.attendeeEmail = _data["attendeeEmail"];
            this.location = _data["location"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): NewMeetingDetails {
        data = typeof data === 'object' ? data : {};
        let result = new NewMeetingDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["timeZone"] = this.timeZone;
        data["attendeeName"] = this.attendeeName;
        data["attendeeEmail"] = this.attendeeEmail;
        data["location"] = this.location;
        data["language"] = this.language;
        return data;
    }
}

export interface INewMeetingDetails {
    start: Date;
    duration: number;
    timeZone: string | undefined;
    attendeeName: string | undefined;
    attendeeEmail: string | undefined;
    location: string | undefined;
    language: string | undefined;
}

export class Time implements ITime {
    hours!: number;
    minutes!: number;

    constructor(data?: ITime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
            this.minutes = _data["minutes"];
        }
    }

    static fromJS(data: any): Time {
        data = typeof data === 'object' ? data : {};
        let result = new Time();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        data["minutes"] = this.minutes;
        return data;
    }
}

export interface ITime {
    hours: number;
    minutes: number;
}

export class TimeRange implements ITimeRange {
    start!: Time;
    end!: Time;

    constructor(data?: ITimeRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.start = data.start && !(<any>data.start).toJSON ? new Time(data.start) : <Time>this.start;
            this.end = data.end && !(<any>data.end).toJSON ? new Time(data.end) : <Time>this.end;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? Time.fromJS(_data["start"]) : <any>undefined;
            this.end = _data["end"] ? Time.fromJS(_data["end"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeRange {
        data = typeof data === 'object' ? data : {};
        let result = new TimeRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toJSON() : <any>undefined;
        data["end"] = this.end ? this.end.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeRange {
    start: ITime;
    end: ITime;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}